
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/announcement",
      function () {
        return require("private-next-pages/announcement.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/announcement"])
      });
    }
  